import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ExportButton, ExportsActionsWrapper, SelectedRange } from './styles'
import RangeDatePicker, { DateRange } from 'components/RangeDatePicker'
import { format } from 'date-fns'
import Button from 'components/Button'
import colors from 'globals/colors'
import { SetState } from 'globals'

interface IProps {
  onExport: (dateRange?: DateRange) => void,
  onDateRangeSelected?: (dateRange: DateRange) => void,
  noRangeDatePicker?: boolean
}

const ExportsActions = (props: IProps) => {
  const { onExport, onDateRangeSelected, noRangeDatePicker } = props
  const { t } = useTranslation()
  const [selectedRange, setSelectedRange] = useState<DateRange>()

  return (
    <ExportsActionsWrapper>
      {!noRangeDatePicker &&
        <>
          <RangeDatePicker
            onValidateRange={onValidateRange(setSelectedRange, onDateRangeSelected)}
          />

          <SelectedRange>
            {t('global.search')} :&nbsp;
            <span>
              {selectedRange ?
                `${format(selectedRange.startDate, 'dd/MM/yyyy')} - ${format(selectedRange.endDate, 'dd/MM/yyyy')}` :
                t('exports.no-date')
              }
            </span>
          </SelectedRange>
        </>
      }

      <ExportButton noMargin={noRangeDatePicker || false}>
        <Button
          size="large"
          disabled={!noRangeDatePicker && !selectedRange}
          color={colors.blueGreen}
          onClick={() => onExport(selectedRange)}
        >
          {t('exports.export-all')}
        </Button>
      </ExportButton>
    </ExportsActionsWrapper>
  )
}

const onValidateRange = (
    setSelectedRange: SetState<DateRange | undefined>,
    onDateRangeSelected?: (dateRange: DateRange) => void
) => (dateRange: DateRange) => {
  setSelectedRange(dateRange)
  onDateRangeSelected && onDateRangeSelected(dateRange)
}

export default ExportsActions
